module.exports = __webpack_public_path__ + "static/media/thumb.f47e0771.png";